function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/badge.ts
import { defineCssVars, defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { transparentize } from "@chakra-ui/theme-tools";
var vars = defineCssVars("badge", ["bg", "color", "shadow"]);
var baseStyle = defineStyle({
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: vars.bg.reference,
  color: vars.color.reference,
  boxShadow: vars.shadow.reference
});
var variantSolid = defineStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  var dark = transparentize("".concat(c, ".500"), 0.6)(theme);
  return _defineProperty(_defineProperty(_defineProperty({}, vars.bg.variable, "colors.".concat(c, ".500")), vars.color.variable, "colors.white"), "_dark", _defineProperty(_defineProperty({}, vars.bg.variable, dark), vars.color.variable, "colors.whiteAlpha.800"));
});
var variantSubtle = defineStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  var darkBg = transparentize("".concat(c, ".200"), 0.16)(theme);
  return _defineProperty(_defineProperty(_defineProperty({}, vars.bg.variable, "colors.".concat(c, ".100")), vars.color.variable, "colors.".concat(c, ".800")), "_dark", _defineProperty(_defineProperty({}, vars.bg.variable, darkBg), vars.color.variable, "colors.".concat(c, ".200")));
});
var variantOutline = defineStyle(function (props) {
  var c = props.colorScheme,
    theme = props.theme;
  var darkColor = transparentize("".concat(c, ".200"), 0.8)(theme);
  return _defineProperty(_defineProperty(_defineProperty({}, vars.color.variable, "colors.".concat(c, ".500")), "_dark", _defineProperty({}, vars.color.variable, darkColor)), vars.shadow.variable, "inset 0 0 0px 1px ".concat(vars.color.reference));
});
var variants = {
  solid: variantSolid,
  subtle: variantSubtle,
  outline: variantOutline
};
var badgeTheme = defineStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
});
export { vars, badgeTheme };